export default "__VITE_ASSET__CrcOUEGz__"